import { Accordion } from 'react-bootstrap';
import { findParents } from '../../../shared/utils/findParent.js';
import { useLocation, useNavigate } from 'react-router-dom';

export const LanguageLocale = ({ data, parent }) => {
  const hasContent = !data.isExpander ? false : true;
  const navigate = useNavigate();
  const location = useLocation();

  const handleClick = (value) => {
    if (!hasContent) {
      const arr = findParents(parent, value);
      navigate(`${location.pathname}/locale?r=${arr.join(',')}`);
    }
  };
  return (
    <Accordion.Item eventKey={`${data.title}_${Date.now()}`}>
      <Accordion.Header
        className={!hasContent ? 'no-toggle' : ''}
        onClick={() => handleClick(data.title)}
      >
        {data.title}
      </Accordion.Header>
      <Accordion.Body style={{ padding: 0 }}>
        {hasContent ? (
          <Accordion style={{ padding: '2px' }} className="custom-accordion">
            {data &&
              data.subPages.map((i) => <LanguageLocale parent={parent} key={i.title} data={i} />)}
          </Accordion>
        ) : null}
      </Accordion.Body>
    </Accordion.Item>
  );
};
